import { z } from 'zod';

import type { CampaignStatus } from '@/services/ws-digital/src/main/resources/rest-api';
import type { IdAccountDto } from '@/services/ws-orders/src/main/resources/rest-api';

export const campaignsListRouterSearchParamsSchema = z.object({
  search: z.string().optional(),
  type: z.custom<CampaignStatus>().optional(),
  accountId: z.custom<IdAccountDto>().optional(),
});
